import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import NoteAddIcon from '@mui/icons-material/NoteAdd'

import Button, { SecondaryIconButton, TableHeaderButton } from '../common/Button'
import { FlexRow } from '../styles/Containers'
import { ErrorText } from '../styles/Text'
import axios from '../../dataClient/dataClient'

const MiniErrorText = styled(ErrorText)`
  font-size: 10px;
  margin: 0;
`

const IconButtonRow = styled(FlexRow)`
  gap: 5px;
  align-items: center;
`

const TextButton = styled(TableHeaderButton)`
  justify-content: flex-start;
  padding: 8px 15px;
  width: 100%;
  height: 100%;
`

function CreateDraftFromTemplateButton({ foiId, type = 'fullButton', letterTemplateId, name = '', handleCreateDraftFromTemplate = () => {} }) {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(false)
  function handleClick() {
    setError(false)
    setIsLoading(true)

    axios
      .post(`/letter/letter-template/${letterTemplateId}/convert-to-draft`, { foiId })
      .then(({ data }) => {
        handleCreateDraftFromTemplate(data.data)
        setIsLoading(false)
      })
      .catch(e => {
        console.error('Failed to create draft from template', letterTemplateId, e)
        setIsLoading(false)
        setError(true)
      })
  }

  if (type === 'icon') {
    return (
      <IconButtonRow>
        <SecondaryIconButton
          onClick={handleClick}
          disabled={isLoading}
          loading={isLoading}
          aria-label={`Create draft from template ${name}`}
          type="button">
          <NoteAddIcon fontSize="small" />
        </SecondaryIconButton>
        {error && <MiniErrorText role="alert">Error, try again.</MiniErrorText>}
      </IconButtonRow>
    )
  }

  if (type === 'text') {
    return (
      <TextButton onClick={handleClick} disabled={isLoading} type="button">
        {isLoading ? '...' : name}
      </TextButton>
    )
  }

  return (
    <Button onClick={handleClick} loading={isLoading} type="button">
      Create Draft from Template
    </Button>
  )
}

CreateDraftFromTemplateButton.propTypes = {
  foiId: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['icon', 'text', 'fullButton']),
  letterTemplateId: PropTypes.string.isRequired,
  name: PropTypes.string,
  handleCreateDraftFromTemplate: PropTypes.func
}

export default CreateDraftFromTemplateButton
